import { Component, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { MatTreeNestedDataSource, MatTreeFlattener,  } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ProductSpecification } from 'situview-webapi-client';

@Component({
  selector: 'product-specification-tree',
  templateUrl: './product-specification-tree.component.html',
  styleUrls: ['./product-specification-tree.component.less']
})
export class ProductSpecificationTreeComponent implements OnChanges {
  @Input() productSpecifications: ProductSpecification[] = [];
  @Input() productTypeIdFilter: string = '';
  @Input() selectedProductSpecificationIds: string[] = [];
  @Input() expandAll: boolean = false;
  @Input() readOnly:  boolean = true;
  @Output() onProductSpecificationSelectionChanged: EventEmitter<string[]> = new EventEmitter();

  treeControl = new NestedTreeControl<ProductSpecificationNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<ProductSpecificationNode>();
  productSpecificationNodes: ProductSpecificationNode[] = [];

  ngOnChanges(changes: SimpleChanges) {
      if (!this.selectedProductSpecificationIds)
      {
        this.selectedProductSpecificationIds = [];
      }

      this.updateTree();
  }

  updateTree() {
    if (!this.productTypeIdFilter) {
      // If productTypeIdFilter is empty, clear the tree
      this.dataSource.data = [];
      return;
    }

    this.productSpecificationNodes = ProductSpecificationNode.Build(this.productSpecifications, this.productTypeIdFilter, this.selectedProductSpecificationIds);
    this.dataSource.data = this.productSpecificationNodes;

    if (this.expandAll) {
      this.productSpecificationNodes.forEach(e => this.treeControl.expand(e));
    } else {
      this.productSpecificationNodes.forEach(e => this.treeControl.collapse(e));
    }
  }

  hasChild(_: number, node: ProductSpecificationNode) {
    return !!node.children && node.children.length > 0;
  }

  toggleNodeSelection(node: ProductSpecificationNode) {
    if (node.hasSelectedChildren()) {
      this.deselectChildren(node);
    } else {
      node.selected = !node.selected;
      this.deselectAncestors(node.parent);
    }

    this.selectedProductSpecificationIds.length = 0;
    this.updateSelectedProductSpecificationIds(this.productSpecificationNodes);

    this.onProductSpecificationSelectionChanged.emit(this.selectedProductSpecificationIds);
  }

  deselectAncestors(node?: ProductSpecificationNode) {
    if (!node) {
      return;
    }
    node.selected = false;

    if (!node.parent) {
      return;
    }
    this.deselectAncestors(node.parent);
  }

  deselectChildren(node?: ProductSpecificationNode) {
    if (!node) {
      return;
    }
    node.selected = false;

    if (!node.children) {
      return;
    }
    node.children.forEach(x => this.deselectChildren(x));
  }
  
  updateSelectedProductSpecificationIds(nodes: ProductSpecificationNode[])
  {
    nodes.forEach(item => {
      if (item.selected && item.productSpecification.id)
      {
        this.selectedProductSpecificationIds.push(item.productSpecification.id);
      }

      if (item.children)
      {
        this.updateSelectedProductSpecificationIds(item.children);
      }
    });
  }

}

class ProductSpecificationNode {
  productSpecification: ProductSpecification;
  selected: boolean;

  children?: ProductSpecificationNode[];
  parent?: ProductSpecificationNode;

  constructor(productSpecification: ProductSpecification,
    parentProductSpecification: ProductSpecificationNode | undefined,
    productSpecifications: ProductSpecification[],
    selectedProductSpecificationIds: string[]) {
    this.productSpecification = productSpecification;
    this.selected = selectedProductSpecificationIds.some(item => item === productSpecification.id);

    this.children = productSpecifications
      .filter(item => item.parentSpecificationId === productSpecification.id)
      .sort((a, b) => (a.order ?? 100000) - (b.order ?? 100000))
      .map(item => new ProductSpecificationNode(item, this, productSpecifications, selectedProductSpecificationIds));

    this.parent = parentProductSpecification;
  }

  static Build(productSpecifications: ProductSpecification[], productTypeIdFilter: string, selectedProductSpecificationIds: string[]) : ProductSpecificationNode[]
  {
    if (productSpecifications && productTypeIdFilter && selectedProductSpecificationIds)
    {
      return productSpecifications
      .filter(item => item.productTypeId == productTypeIdFilter && !item.parentSpecificationId)
      .sort((a, b) => (a.order ?? 100000) - (b.order ?? 100000))
      .map(item => new ProductSpecificationNode(item, undefined, productSpecifications, selectedProductSpecificationIds));
    }
    else
    {
      return [];
    }
  }

  hasSelectedChildren() : boolean
  {
    if (!this.children) {
      return false;
    }

    return this.children.some(item => item.selected || item.hasSelectedChildren());
  }
}